import script from "./UserCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=151ee01d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src014250190/src/byggesoknaden-support-gui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151ee01d"]])

export default __exports__